import React, { useState } from 'react';
import MealMetadataInfo from 'components/meal-content/meal-metadata-page';
import { Button, ToastMessage } from '@cokitchen/cokitchen-components';
import useMealContext from 'contexts/meal.context';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import { SuccessModal } from 'components/base/success-modal';

const EditMealMetadataInfo = () => {
  const [loading, setLoading] = useState(false);
  const { formData, meal, resetForm } = useMealContext();
  const [showSuccess, setShowSuccess] = useState(false);

  const updateBrandDetails = async () => {
    const { meal_keywords, meal_business_metadatas, meal_descriptive_metadatas } = formData;
    setLoading(true);
    const payload = {
      meal_id: meal?.id,
      ...(meal_business_metadatas.length && { meal_business_metadatas }),
      ...(meal_descriptive_metadatas.length && { meal_descriptive_metadatas }),
      ...(meal_keywords.length && { meal_keywords })
    };
    try {
      const res = await apiService.put('marketing/meal-new', {
        data: payload
      });
      if (res?.data) {
        setShowSuccess(true);
      }
    } catch (error: any) {
      toast(<ToastMessage type='error' message={error?.response?.data?.message} />);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div>
      <MealMetadataInfo />

      <div className='flex justify-end gap-6 mt-16'>
        <Button color='primary' className='text-sm' small variant='link' onClick={resetForm}>
          Undo Changes
        </Button>
        <Button
          loading={loading}
          className='text-sm max-w-[150px]'
          onClick={updateBrandDetails}
          color='primary'
          small
          variant='block'>
          Confirm
        </Button>
      </div>
      <SuccessModal onClose={() => setShowSuccess(false)} show={showSuccess}>
        Meal updated successfully
      </SuccessModal>
    </div>
  );
};

export default EditMealMetadataInfo;
